import { Alert, Snackbar, Typography } from "@mui/material";
import { LogSearchKind, Role } from "../../app/backendTypes";
import { useAppSelector } from "../../app/hooks";
import { useNavigate } from "react-router-dom";

export default function Morselbar(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  content: string;
  error: string | undefined;
}) {
  const { open, setOpen, content, error } = props;

  const isAdmin = useAppSelector((state) =>
    state.auth.roles.includes(Role.Administrator)
  );

  const navigate = useNavigate();
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={5000}
      onClose={() => setOpen(false)}
    >
      <Alert
        severity={error ? "error" : "success"}
        variant="filled"
        onClick={
          error && isAdmin
            ? () =>
                navigate(
                  `/admin/logs?kind=${LogSearchKind.Request}&value=${error}`
                )
            : undefined
        }
      >
        {error && isAdmin ? (
          <>
            {content}{" "}
            <Typography variant="inherit" component="span" fontWeight="bold">
              (click for logs)
            </Typography>
          </>
        ) : (
          content
        )}
      </Alert>
    </Snackbar>
  );
}
